import { render } from "./ColorInput.vue?vue&type=template&id=25b0fa4c&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"

import "./ColorInput.vue?vue&type=style&index=0&id=25b0fa4c&scoped=true&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b0fa4c"]])

export default __exports__